module.exports = __webpack_public_path__ + "static/research_card_img3@2x-60fc3400db295bafe3eb48d4d382262b.jpg";